import { Nullable, OneOrMore } from '@internal-libraries/kheops-ui-lib'
import { GroupData } from '../Types/GroupData'
import { GroupDto } from '../Types/GroupDto'
import { GroupApiAdapter } from '../Adapters/GroupApiAdapter'

export default class Group {
    public id: Nullable<number> = null

    public text = ''

    public constructor({ id = null, text = '' }: GroupData) {
        this.id = id
        this.text = text
    }

    public toDto(): GroupDto {
        return {
            id: this.id,
            text: this.text,
        }
    }

    public static instantiateGroupsFromDto(refGroups: OneOrMore<GroupDto>): Group[] {
        return Array.isArray(refGroups)
            ? refGroups.map(new GroupApiAdapter().createClass)
            : [new GroupApiAdapter().createClass(refGroups)]
    }
}
